import PeriprocedureelBeleidVKA from "../../../../src/client/lta-antistolling/periprocedureel-beleid-vka.json";
import * as React from 'react';
export default {
  PeriprocedureelBeleidVKA,
  React
};